import React from 'react'

import type { GetServerSideProps, NextPage } from 'next'

import ConcertsCategoryContent from '@/components/pages/concerts/components/category-content'
import type { CategoryPageProps } from '@/components/shared/category/types'
import { getServerSidePropsByCategoryId } from '@/components/shared/category/utils'
import { CATEGORY_ANALYTICS_ID_MAP, CATEGORY_IDS, CATEGORY_PAGE_TYPE_MAP } from '@/constants'
import { AnalyticsProvider } from '@/context/analytics'
import { CategoryProvider } from '@/context/category'

const ConcertsCategoryPage: NextPage<CategoryPageProps> = (props) => {
    const { initialCategoryParams, initialCategory } = props

    return (
        <AnalyticsProvider
            initialProps={{
                id: CATEGORY_ANALYTICS_ID_MAP[initialCategoryParams.categoryId],
                pageType: CATEGORY_PAGE_TYPE_MAP[initialCategoryParams.categoryId],
            }}
        >
            <CategoryProvider
                initialParams={initialCategoryParams}
                initialProps={initialCategory ? { data: initialCategory } : undefined}
            >
                <ConcertsCategoryContent {...props} />
            </CategoryProvider>
        </AnalyticsProvider>
    )
}

ConcertsCategoryPage.displayName = 'ConcertsCategoryPage'

export const getServerSideProps: GetServerSideProps<CategoryPageProps> = getServerSidePropsByCategoryId(
    CATEGORY_IDS.CONCERTS,
)

export default ConcertsCategoryPage
